export default __webpack_public_path__ + "static/media/alur-box-1.357596a4.png";